// extracted by mini-css-extract-plugin
export var box = "RBBqiBGJO100J472vSia";
export var chevron = "wtUAxmcTbhIBRgZv4f0M";
export var chevronlink = "rkIaQpsihap_Jfhwqny_";
export var close = "brUt7pvvaMzVXG5Rcicc";
export var content = "E3VAoT5STSFfsU86QILg";
export var message = "jfBPc3XLDv4eqgtUv6gk";
export var open = "C0GBLKBB0hDv84RBCzp8";
export var root = "I81tunzgNI1Actrzn8r7";
export var slider = "FW0KFrXqfUtcTLwqDIsS";
export var title = "Fw3DHjfCrkgdDxQS2Wiq";
export var trigger = "IV5JTC4HE5_LlaBOVmib";